import React from 'react';
import markdownIt from 'markdown-it';
import markdownItSup from 'markdown-it-sup';
import markdownItSanitizer from 'markdown-it-sanitizer';
import markdownItClass from '@toycode/markdown-it-class';
import markdownItLinkAttributes from 'markdown-it-link-attributes';
import '../../../../../../../../../../styles.css';
import { getCorrectComponent } from '../../../../../../../../../../utils/getCorrectComponent';
import { timeStamp } from '../../../../../../../../../../utils/helper';

function Message({ message, showTimeStamp }) {
  const sanitizedHTML = markdownIt({ break: true })
    .use(markdownItClass, { img: ['rcw-message-img'] })
    .use(markdownItSup)
    .use(markdownItSanitizer)
    .use(markdownItLinkAttributes, { attrs: { target: '_blank', rel: 'noopener' } });

  return (
    <div className={`rcw-${message.sender}`}>
      <div className="rcw-message-text">
        {typeof message.text === 'object'
          ? getCorrectComponent(message?.text)
          : getCorrectComponent(message)}
      </div>
      {/* {showTimeStamp && <span className="rcw-timestamp">{timeStamp(message.timestamp)}</span>} */}
    </div>
  );
}

export default Message;
